import React from 'react';
import ReactDOM from 'react-dom/client';
import Pathes from './pathes';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <Pathes />
  </React.StrictMode>
);


